import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import { CSSTransition } from 'react-transition-group';

import Snackbar from '@components/common/SnackbarsContainer/Snackbar';

import { ISnackbarsContainerProps } from '@interfaces/notifications/snackbar';

import '@styles/global.scss';
import styles from './SnackbarsContainer.module.scss';

const TIMEOUT = 500;

const SnackbarsContainer = ({
	snackbars,
}: ISnackbarsContainerProps) => {
	const nodeRef = useRef<any>(null);

	return (
		<CSSTransition
			appear
			classNames='snackbars-transition'
			in={!!snackbars?.length}
			mountOnEnter
			nodeRef={nodeRef}
			timeout={TIMEOUT}
			unmountOnExit
		>
			<div
				ref={nodeRef}
				className={styles.snackbarsContainer}
			>
				{!!snackbars?.length && snackbars.map(({ id, message, type }) => {

					return (
						<Snackbar
							key={id}
							id={id}
							message={message}
							type={type}
						/>
					);
				})}
			</div>
		</CSSTransition>
	);
};

const SnackbarPortal = ({
	snackbars,
}: ISnackbarsContainerProps) => createPortal(
	<SnackbarsContainer snackbars={snackbars} />,
	document.body,
);

export default SnackbarPortal;
